<template>
  <header class="main-header">
    <!-- Logo -->
    <router-link :to="{ name: 'dashboard' }" class="logo">
      <!-- mini logo for sidebar mini 50x50 pixels -->
      <span class="logo-mini">OJS</span>
      <!-- logo for regular state and mobile devices -->
      <span class="logo-lg">OJS</span>
    </router-link>
    <!-- Header Navbar: style can be found in header.less -->
    <nav class="navbar navbar-static-top">
      <!-- Sidebar toggle button-->
      <div class="navbar-custom-menu">
        <ul class="nav navbar-nav">
          <!-- User Account: style can be found in dropdown.less -->
          <li class="dropdown user user-menu">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
              <img v-bind:src="picture" class="user-image" alt="User Image">
              <span class="hidden-xs">{{ fullname }}</span>
            </a>
            <ul class="dropdown-menu">
              <!-- User image -->
              <li class="user-header">
                <img v-bind:src="picture" class="img-circle" alt="User Image">

                <p>
                  {{ fullname }}
                  <small>{{ email }}</small>
                </p>
              </li>
              <!-- Menu Footer-->
              <li class="user-footer">
                <div class="pull-right">
                  <a class="btn btn-default btn-flat" @click.prevent="logout">Déconnexion</a>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
  export default {
    name: 'DashboardHeader',
    data: function () {
      return {
        'firstname': '',
        'lastname': '',
        'email': '',
        'picture': ''
      }
    },
    computed: {
      fullname: function () {
        return this.firstname + ' ' + this.lastname
      }
    },
    methods: {
      logout: function () {
        this.$store.commit('REMOVE_TOKEN')

        if (window.localStorage) {
          window.localStorage.removeItem('token')
        }

        this.$router.push('/login')
      }
    },
    created: function () {
      let token = localStorage.getItem('token')
      this.$http.get('http://ws.ojssymphonique.net/api/user?token=' + token).then(function (data) {
        this.firstname = data.body.data.firstname
        this.lastname = data.body.data.lastname
        this.email = data.body.data.email
        let gravatar = require('gravatar')
        this.picture = gravatar.url(this.email)
      })
    }
  }
</script>



// WEBPACK FOOTER //
// Header.vue?23bfe895